import CitySEOHead from "@/components/feature/CitySEOHead";
import MiltonHeroSection from "./components/HeroSection";
import MiltonStickyNav from "./components/StickyNav";
import MiltonProcessingTimeSection from "./components/ProcessingTimeSection";
import MiltonServicesSection from "./components/ServicesSection";
import MiltonLocalAreaSection from "./components/LocalAreaSection";
import MiltonTestimonialsSection from "./components/TestimonialsSection";
import MiltonAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import MiltonComparisonSection from "./components/ComparisonSection";
import MiltonMistakesSection from "./components/MistakesSection";
import MiltonHowItWorksSection from "./components/HowItWorksSection";
import MiltonFAQSection, { faqs } from "./components/FAQSection";
import MiltonHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import MiltonFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function MiltonPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Milton"
        state="Georgia"
        stateAbbr="GA"
        route="/milton"
        title="Emergency Passport Milton, GA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Milton, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving North Fulton County travelers. Get your emergency passport fast!"
        keywords="expedited passport, emergency passport, Milton passport, same day passport Atlanta, fast passport Georgia"
        geoPlacename="Milton, Georgia"
        geoPosition="34.1322;-84.3007"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Georgia"
        statePageRoute="/states/georgia"
      />
      <MiltonHeroSection />
      <MiltonStickyNav />
      <MiltonProcessingTimeSection />
      <MiltonServicesSection />
      <MiltonLocalAreaSection />
      <MiltonTestimonialsSection />
      <MiltonAcceptanceFacilitiesSection />
      <MiltonComparisonSection />
      <MiltonMistakesSection />
      <MiltonHowItWorksSection />
      <MiltonFAQSection />
      <MiltonHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/milton" state="GA" />
      <MiltonFinalCTA />
    </div>
  );
}